import type { Client } from '../../api/client.js';
import type { PlanRelance, Simulation } from './contrat.js';
import { phraseErreur } from './erreurs.js';

export type ResultatPlan = { ok: true; plan: PlanRelance; message?: undefined } | { ok: false; message: string };
export type ResultatSimulation = { ok: true; simulation: Simulation } | { ok: false; message: string };

/** Pause « on laisse respirer » : le motif (3 caractères au moins) est obligatoire. */
export async function mettreEnPause(client: Client, planId: string, motif: string, jusquau: string | null): Promise<ResultatPlan> {
  const reason = motif.trim();
  if (reason.length < 3) return { ok: false, message: 'Indiquez le motif de la pause (3 caractères au moins).' };
  try {
    return {
      ok: true,
      plan: await client.appeler<PlanRelance>('relances.pause', { parametres: { planId }, corps: { reason, until: jusquau } }),
    };
  } catch (e) {
    return { ok: false, message: phraseErreur(e) };
  }
}

export async function reprendre(client: Client, planId: string): Promise<ResultatPlan> {
  try {
    return { ok: true, plan: await client.appeler<PlanRelance>('relances.reprise', { parametres: { planId } }) };
  } catch (e) {
    return { ok: false, message: phraseErreur(e) };
  }
}

/** Simulation sans effet : rien n'est programmé. */
export async function simuler(client: Client, e: { dossierId: string; personId: string; depuis: string }): Promise<ResultatSimulation> {
  try {
    const simulation = await client.appeler<Simulation>('relances.simuler', {
      corps: { dossierId: e.dossierId, personId: e.personId, from: e.depuis },
    });
    return { ok: true, simulation };
  } catch (err) {
    return { ok: false, message: phraseErreur(err) };
  }
}
